export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_shift-sales-monitor/artifacts/ipdwtf3y_66117d382adb5bef0e2466f1_Promotify%20Logo%20enlarged.png";

export function Logo({ size = 40, className = "" }) {
  return (
    <div
      className={`inline-flex items-center justify-center bg-slate-900 rounded-xl shadow-md shadow-slate-900/20 overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-logo"
    >
      <img
        src={LOGO_URL}
        alt="Promotify"
        className="w-full h-full object-contain"
        style={{ padding: "10%" }}
      />
    </div>
  );
}

export function BrandMark({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <Logo size={compact ? 36 : 44} />
      <div className="leading-tight">
        <div className="font-display font-semibold text-[15px] sm:text-base tracking-tight uppercase">
          UBBS Consumer Engagement
        </div>
        <div className="font-mono text-[10px] sm:text-[11px] text-neutral-500 uppercase tracking-[0.18em]">
          Field Force
        </div>
      </div>
    </div>
  );
}
